const React = require("react");
const PropTypes = require("prop-types");

const loadDatabank = require("ok-databank");

class Databank extends React.Component {
  constructor(props) {
    super(props);

    this.databankEventHandler = e => this.handleDatabankEvent(e);
  }

  componentDidMount() {
    this.subscribeToDatabank();

    const {
      language,
      environment,
      friendlyName,
      messages
    } = this.props;

    const userDetails = {firstName: friendlyName};

    loadDatabank(environment, language, userDetails, messages);
  }

  componentWillUnmount() {
    this.unsubscribeFromDatabank();
  }

  subscribeToDatabank() {
    window.addEventListener("message", this.databankEventHandler, false);
  }

  unsubscribeFromDatabank() {
    window.removeEventListener("message", this.databankEventHandler, false);
  }

  handleDatabankEvent(event) {
    if (event.origin === window.location.origin) {
      this.props.onDatabankEvent(event.data.type, event.data.message);
    }
  }

  render() {
    return <div id="dkRoot" />
  }
}

Databank.propTypes = {
  language: PropTypes.string.isRequired,
  environment: PropTypes.string.isRequired,
  friendlyName: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  onDatabankEvent: PropTypes.func.isRequired
}

module.exports.Databank = Databank;
